import React from 'react';

import { AttentionLabel, Label } from '@eika/label';

import type { AccountWithdrawalDetails } from '../../../generated-types';
import useTranslation, { format } from '../../../hooks/useTranslation';
import getFreeWithdrawalStatus from '../../../utils/mapper/getFreeWithdrawalStatus';

type AccountFreeWithdrawalLabelProps = {
    freeWithdrawals?: AccountWithdrawalDetails | null;
    className?: string;
};

const AccountFreeWithdrawalLabel: React.FC<AccountFreeWithdrawalLabelProps> = ({ freeWithdrawals, className }) => {
    const translated = useTranslation();
    if (!freeWithdrawals) {
        return null;
    }
    const { showFreewithdrawal, remainingWithdrawals } = getFreeWithdrawalStatus(freeWithdrawals);
    if (!freeWithdrawals || !showFreewithdrawal) {
        return null;
    }

    if (remainingWithdrawals <= 0) {
        return <AttentionLabel className={className} text={translated.withdrawals.noWithdrawalsLeft} />;
    }

    const formattedWithdrawalText =
        remainingWithdrawals > 1
            ? format(
                  translated.withdrawals.infoAboutNumberOfWithdrawalsLeft,
                  remainingWithdrawals,
                  translated.withdrawals.withdrawalPeriods[freeWithdrawals.freeWithdrawalPeriod ?? 'UKNOWN'],
              )
            : format(
                  translated.withdrawals.oneWithdrawalLeft,
                  translated.withdrawals.withdrawalPeriods[freeWithdrawals.freeWithdrawalPeriod ?? 'UKNOWN'],
              );

    return <Label className={className} text={formattedWithdrawalText} />;
};

export default AccountFreeWithdrawalLabel;
